import './crfListing.css';
import { useEffect, useState } from "react";
import { getCrfListing } from "../../api/searchApi";
import CrfTable from './crfTable';

const CrfListing = () => {
    const [results, setResults] = useState(null);
    const [isExpanded, setIsExpanded] = useState([]);
    const [allExpanded, setAllExpanded] = useState(false);

    useEffect(() => {
        const doSearch = async () => {
            const results = await getCrfListing();
            //console.log(results);
            setResults(results);

            // construct isExpanded
            const newIsExpanded = [];
            results.forEach(domain => domain.subDomainGroups.forEach(subDomain => {
                if (!newIsExpanded.some(exp => exp.key === `${domain.domainId}_${subDomain.subDomainId}`))
                    newIsExpanded.push({ key: `${domain.domainId}_${subDomain.subDomainId}`, value: false });
            }));

            setIsExpanded(newIsExpanded);
        };

        doSearch();
    }, []);

    const toggleAllExpandedHandler = () => {
        setAllExpanded(prevAll => {
            const newIsExpanded = [...isExpanded];
            newIsExpanded.forEach(exp => exp.value = !prevAll);

            setIsExpanded(newIsExpanded);

            return !prevAll;
        });
    };

    const toggleExpandedHandler = key => {
        const entry = isExpanded.find(exp => exp.key === key);
        entry.value = !entry.value;

        setIsExpanded([entry, ...isExpanded]);
    };

    const getIsExpanded = key => isExpanded?.find(exp => exp.key === key)?.value ?? false;

    if (!results)
        return null;

    return (
        <>
            <button className="expand-all" onClick={e => toggleAllExpandedHandler(e)}>{allExpanded ? 'Collapse All' : 'Expand All'}</button>
            {results.map(domain => (
                <div key={domain.domainId} className="view-grouping">
                    <div className="view-grouping-header">{domain.domainName}</div>
                    <div className="view-grouping-content">
                        {domain.subDomainGroups.map(subDomain => {
                            const expanded = getIsExpanded(`${domain.domainId}_${subDomain.subDomainId}`);

                            return <CrfTable
                                key={subDomain.subDomainId}
                                domain={domain}
                                subDomain={subDomain}
                                crfs={subDomain.crfs}
                                isExpanded={expanded}
                                toggleExpanded={toggleExpandedHandler}
                            />
                        })}
                    </div>
                </div>
            ))}
        </>
    );
};

export default CrfListing;